import * as React from 'react';
export const paneSvg = React.forwardRef(function paneSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 4.5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-7ZM10.5 3H13a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 13 13h-2.5V3ZM9 3H3a1.5 1.5 0 0 0-1.5 1.5v7A1.5 1.5 0 0 0 3 13h6V3Z',
    }),
  );
});
paneSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pane = {
  category: 'icon',
  colorable: true,
  name: 'pane',
  svg: paneSvg,
};
